import React from 'react';
import { Form } from '../../../ui/universe';
import { getSelectRectKey } from '../utils';

/**
 * Store 渲染器 - 门店识别结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.detail - 菜单详情配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const StoreRenderer = ({ params, detail, selectRect, onSelect }) => {
  return (
    <>
      <Form.Item label="图片类型">
        {params.StoreLabel?.includes('标准门头照') ? '标准门头照' : '非标准门头照'}
      </Form.Item>
      {params.StoreInfo?.map((i, index) => {
        const selectRectVal = getSelectRectKey({
          data: i,
          key: detail?.rectConfig?.RectKey,
          valStr: i.Value
        });

        return (
          <Form.Item
            className={`${selectRectVal && selectRect === selectRectVal ? 'isSelect' : ''}`}
            key={index}
            label={i.Name}
            onClick={() => {
              onSelect && onSelect(i.Value, selectRectVal);
            }}
          >
            {i.Value}
          </Form.Item>
        );
      })}
    </>
  );
};

export default StoreRenderer;
